/* unplugin-vue-components disabled */import script from "./Asyntask.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asyntask.vue?vue&type=script&setup=true&lang=ts"

import "./Asyntask.vue?vue&type=style&index=0&id=3cb576fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb576fe"]])

export default __exports__